import React, {useState, useEffect} from 'react';
import ModalWrapper from './DetailModal/ModalWrapper';
import Table from './Table/Table';
import SearchWrapper from "./Search/SearchWrapper";
import {firebase} from "../../firebase/firebaseConfig";
import { Route } from 'react-router-dom';

//Material UI I
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import {Alert, Button} from 'react-bootstrap';

export default function Forum() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadMore, setLoadMore] = useState(false);
  const [noMore, setNoMore] = useState(false);

  //Logging refresh for analytics
  useEffect(() => firebase.analytics().logEvent('forum_refresh'), []);

  let tableComponent;
  if (posts && posts.length !== 0) {
    tableComponent = <Table posts={posts} setPosts={setPosts}/>;
  } else if (loading) {
    tableComponent = <CircularProgress className="mt-5"/>
  } else if (posts && posts.length === 0) {
    firebase.analytics().logEvent('no_posts_found');
    tableComponent = (
      <Alert variant="danger" className="mx-auto text-left table-alert">
        <Alert.Heading>Sorry... We Couldn't Find Any Posts</Alert.Heading>
        <p>
          Maybe try reloading the page? 
          Or if you're feeling lucky, you could try the advanced search 😉
        </p>
      </Alert>);
  }

  return (
    <div className="py-5 bg-light">
      <Route path="/forum/posts/:postID">
        <ModalWrapper posts={posts} setPosts={setPosts}/>
      </Route>
      <h1 className="pt-5">Find the Next Big Idea</h1>
      <SearchWrapper setState={setPosts} setLoading={setLoading} loadMore={loadMore} setLoadMore={setLoadMore} existingPosts={posts} setNoMore={setNoMore}/>
      <Grid item xs={12}>
        {tableComponent}
      </Grid>
      <Button 
      variant={noMore ? "outline-danger" : "outline-success"} 
      disabled={noMore ? true : false} 
      onClick={() => setLoadMore(true)}>
      {noMore ? 'All Posts Loaded. Try a different search?' : 'Load More'}</Button>
    </div>
  )
}